import { PROD_MEDIA_SERVER } from '../constants';
import { Thumbnail, VideoSourceData } from '../types';
export * from './vtt';
export * from './captionsTranscript';

export const getBestThumb = (
  thumbnail?: Thumbnail,
  isMobile?: boolean,
): string => {
  const { muxThumb, muxThumbSmall, $$ } = thumbnail || {};
  const smallThumb = muxThumbSmall || $$;
  const regularThumb = muxThumb || $$;

  const selectedThumb = isMobile ? smallThumb : regularThumb;

  return selectedThumb ? `${PROD_MEDIA_SERVER}${selectedThumb}` : '';
};

export const getThumbnailsFromVideoData = (
  data?: VideoSourceData,
): Thumbnail => {
  const { muxThumb, muxThumbSmall, $$ } = data || {};
  return { muxThumb, muxThumbSmall, $$ };
};

/**
 * Transform string to duration.
 */
export const formatSecondsToDuration = (seconds: string | number) => {
  if (!seconds || +seconds <= 0) {
    return null;
  }
  try {
    const date = new Date(0);
    date.setSeconds(+seconds);
    const timeString = date.toISOString().substring(11, 19);

    return /^00:/.test(timeString)
      ? timeString.replace('00:', '')
      : timeString.replace(/^0/, '');
  } catch {
    return null;
  }
};

export const nameToLearnUrl = (name: string) =>
  `/learn/${name?.replace(/\s/g, '_').replace(/\//g, '')}`;
